import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromReducer from './device-sync-status.reducer';
import { DeviceSyncStatusState } from './device-sync-status.state';
import { isDeviceInCorrectSyncState } from './device-sync-status.utils';

import { DevicesRouterStoreSelectors } from '@era/stores';

export const selectDeviceSyncStatusState = createFeatureSelector<DeviceSyncStatusState>(
  fromReducer.deviceSyncStatusFeatureKey
);

export const selectDeviceSyncStatusIds = createSelector(
  selectDeviceSyncStatusState,
  fromReducer.selectDeviceSyncStatusIds
);

export const selectDeviceSyncStatusEntities = createSelector(
  selectDeviceSyncStatusState,
  fromReducer.selectDeviceSyncStatusEntities
);

export const selectAllDeviceSyncStatuses = createSelector(
  selectDeviceSyncStatusState,
  fromReducer.selectDeviceSyncStatuses
);

export const selectCurrentDeviceSyncStatus = createSelector(
  selectDeviceSyncStatusEntities,
  DevicesRouterStoreSelectors.selectUdid,
  (entities, udid) => {
    const status = udid && entities?.[udid];
    return status
      ? status
      : {
          udid,
        };
  }
);

export const selectIsDeviceInCorrectSyncState = (deviceId: string) =>
  createSelector(selectDeviceSyncStatusEntities, (entities) => isDeviceInCorrectSyncState(entities?.[deviceId]));
